import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SubmissionError } from 'redux-form';
import PlusCircleOutlineIcon from 'mdi-react/PlusCircleOutlineIcon';
import TrashCanIcon from 'mdi-react/TrashCanIcon';
import Button from 'components/buttons/Button';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import { find, first, isEmpty, findLast, last } from 'lodash';
import * as Moment from 'moment';

import { secondsToDays } from 'utils/misc';
import { transformSteps, orderSteps } from 'utils/steps';
import Pitch from 'components/steps/Pitch';
import DestroyModal from 'components/modals/DestroyModal';
import NotificationSystem from 'rc-notification';
import BasicNotification from 'components/Notification';
import {
  NOTIFICATION_NODE_STYLE,
} from 'constants/misc';
import StepDurationForm from 'components/steps/StepDurationForm';
import { toggleDestroyModal } from 'redux/actions/destroyModalActions';
import { createStep, destroyStep, updateStep, getSteps } from 'redux/actions/stepActions';
import {
  createPitch,
  getPitches,
  updatePitch,
  destroyPitch,
  createTemplatePitch,
  getTemplatePitches,
  updateTemplatePitch,
} from 'redux/actions/pitchActions';
import { getCsvTemplateFields } from 'redux/actions/csvTemplateFieldActions';
import { getSequence, updateSequence } from 'redux/actions/sequenceActions';
import { Can, AbilityContext } from 'utils/permissions';
import CustomizedEmailModal from './CustomizedEmailModal';
import ConfirmationModal from '../modals/ConfirmationModal';
import PitchAddModal from '../modals/PitchAddModal';


const ADD_STEP_BUTTON_TEXT = 'Add Step';
const ADD_PITCH_BUTTON_TEXT = 'Add Variant';
const FIRST_STEP = 0;
const EMPTY_PITCH = {
  name: null,
  subject: null,
  body: null,
  collapsed: false,
  is_template: false,
  inherits_subject: true,
};
const EMPTY_STEP = {
  pitches: [EMPTY_PITCH],
  send_from_launch_duration: Moment.duration(0, 'seconds').toISOString(),
  id: null,
};

const DAYS_TO_ADD = 3;

class Steps extends Component {
  static propTypes = {
    pitchQualityCheckOpen: PropTypes.bool,
    toggleDestroyModal: PropTypes.func.isRequired,
    createStep: PropTypes.func.isRequired,
    updateStep: PropTypes.func.isRequired,
    getSequence: PropTypes.func.isRequired,
    destroyStep: PropTypes.func.isRequired,
    getSteps: PropTypes.func.isRequired,
    createPitch: PropTypes.func.isRequired,
    updatePitch: PropTypes.func.isRequired,
    updateSequence: PropTypes.func.isRequired,
    destroyPitch: PropTypes.func.isRequired,
    getTemplatePitches: PropTypes.func.isRequired,
    createTemplatePitch: PropTypes.func.isRequired,
    updateTemplatePitch: PropTypes.func.isRequired,
    getCsvTemplateFields: PropTypes.func.isRequired,
    changeCanLaunch: PropTypes.func,
    // eslint-disable-next-line react/no-unused-prop-types
    steps: PropTypes.arrayOf(PropTypes.shape({
      pitches: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        subject: PropTypes.string,
        body: PropTypes.string,
      })),
    })).isRequired,
    step: PropTypes.shape({
      id: PropTypes.number,
      loading: PropTypes.bool,
    }),
    templatePitches: PropTypes.shape({}).isRequired,
    pitch: PropTypes.shape({
      id: PropTypes.number,
    }),
    sequence: PropTypes.shape({
      id: PropTypes.number,
      account_id: PropTypes.number,
    }),
    togglePitchPreview: PropTypes.func,
    togglePitchQualityCheck: PropTypes.func,
    updatePitchPreviewData: PropTypes.func,
  };
  static defaultProps = {
    pitchQualityCheckOpen: false,
    sequence: {},
    step: {},
    pitch: {},
    changeCanLaunch: () => {},
    togglePitchPreview: undefined,
    togglePitchQualityCheck: undefined,
    updatePitchPreviewData: () => {},
  }

  constructor(props) {
    super(props);
    this.state = {
      steps: [],
      customizedEmailModalOpen: false,
      customizedEmails: null,
      pitchTemplateToUpdate: {},
      currentStepIndex: null,
      currentPitchIndex: null,
      updatingPitchIndex: null,
      updatingStepIndex: null,
      isUpdatePitchModalOpen: false,
      updateFormData: null,
      isAddPitchDialogOpen: false,
      newPitchStepIndex: null,
      formNotSaved: false,
    };
  }

  componentDidMount() {
    const { sequence } = this.props;
    // eslint-disable-next-line no-return-assign
    NotificationSystem.newInstance({}, n => this.notification = n);
    this.props.getCsvTemplateFields();
    this.canLaunch();

    if (sequence.account_id) {
      this.getPitchTemplates();
    }
  }

  setFormNotSaved = (value) => {
    this.setState({
      ...this.state,
      formNotSaved: value,
    });
  }

  componentDidUpdate(prevProps) {
    const { steps, sequence } = this.props;
    if (!isEqual(prevProps.steps, steps)) {
      this.setFormNotSaved(false);
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        steps: transformSteps(steps),
      }, () => {
        this.canLaunch();
      });
    }
    if (sequence.account_id && !isEqual(prevProps.sequence.account_id, sequence.account_id)) {
      this.getPitchTemplates();
    }
  }

  componentWillUnmount() {
    if (this.notification) this.notification.destroy();
    if (this.props.sequence.id) {
      this.destroyUnsavedPitchSteps();
    }
  }

  onAddPitchDialogCancel = () => {
    this.setState({ isAddPitchDialogOpen: false });
  }

  getPitchTemplates() {
    const { sequence } = this.props;
    this.props.getTemplatePitches({
      account: sequence.account_id,
    });
  }

  getStepTitle = (step, key) => {
    const { steps } = this.state;
    const duration = step.send_from_launch_duration;
    const prevStep = steps[key - 1];
    const nextStep = steps[key + 1];
    const prevDuration = prevStep ? secondsToDays(Moment.duration(prevStep.send_from_launch_duration).asSeconds()) : 0;
    const nextDuration = nextStep ? secondsToDays(Moment.duration(nextStep.send_from_launch_duration).asSeconds())
      : null;
    const durationInDays = secondsToDays(Moment.duration(duration).asSeconds());

    return (
      <StepDurationForm
        form={`duration-form-${key}`}
        step={step}
        stepKey={key}
        durationInDays={durationInDays}
        prevDuration={prevDuration}
        nextDuration={nextDuration}
        disabled={!this.context.can('edit', 'Step Delay')}
        initialValues={{
          days: durationInDays,
        }}
        updateStep={this.changeStepDuration}
      />
    );
  }

  getPitchSubject = (steps, currentStepIndex) => (
    first(findLast(steps, step => find(step.pitches, 'subject'), currentStepIndex).pitches).subject
  )

  canLaunch = () => {
    const { steps } = this.state;
    if (!isEmpty(steps) && !isEmpty(first(steps).pitches)) {
      this.props.changeCanLaunch(true);
    } else {
      this.props.changeCanLaunch(false);
    }
  }

  destroyStep = async (stepIndex) => {
    const { steps } = this.state;
    const step = steps.splice(stepIndex, 1);
    this.props.toggleDestroyModal();
    await this.props.destroyStep(step[0].id);
    if (steps.length === 0) {
      this.props.updateSequence(
        this.props.sequence.id,
        { status: false },
      );
    }
    this.setState({
      steps,
    }, () => {
      this.canLaunch();
    });

    this.props.getSteps({
      sequence: this.props.sequence.id,
    });
  };

  toggleDestroyModal = (stepIndex) => {
    this.props.toggleDestroyModal(stepIndex, `Step ${stepIndex + 1}`);
  };

  toggleIsConfirmModalOpen = (updatingStepIndex, updatingPitchIndex, formData) => {
    this.setState({
      isUpdatePitchModalOpen: !this.state.isUpdatePitchModalOpen,
      updatingStepIndex,
      updatingPitchIndex,
      updateFormData: formData,
    });
  };

  updatePitch = async () => {
    const {
      updatingStepIndex,
      updatingPitchIndex,
      updateFormData,
      steps,
    } = this.state;
    const { templatePitches } = this.props;
    try {
      // Update steps pitch
      this.savePitch(updatingStepIndex, updatingPitchIndex, updateFormData, false);
      // Find template pitch id and update it.
      const templatePitchId = find(templatePitches.results, t => (
        t.name.toLowerCase() === updateFormData.name.toLowerCase()
      )).id;
      const pitchTemplateSubject = updateFormData.inherits_subject ?
        this.getPitchSubject(steps, updatingStepIndex) : updateFormData.subject;
      await this.props.updateTemplatePitch(templatePitchId, {
        account: this.props.sequence.account_id,
        ...updateFormData,
        subject: pitchTemplateSubject,
      });
      // reload pitch and steps
      await this.getPitchTemplates();
      this.props.getSteps({
        sequence: this.props.sequence.id,
      });
    } catch (error) {
      this.showNotification(error.errors);
    }
    this.toggleIsConfirmModalOpen();
  };

  changeStepDuration = (formData, stepIndex) => {
    const { steps } = this.state;
    const dayDuration = Moment.duration(parseInt(formData.days, 10), 'days').toISOString();
    const stepId = steps[stepIndex].id;
    steps[stepIndex].send_from_launch_duration = dayDuration;
    const stepsOrdered = orderSteps(steps);

    this.setState({
      steps: stepsOrdered,
    }, () => this.props.updateStep(stepId, { send_from_launch_duration: dayDuration }));
  }

  addStep = async () => {
    const { steps } = this.state;
    const { sequence } = this.props;
    const totalExistingSteps = steps.length;
    const newStep = cloneDeep(EMPTY_STEP);
    if (totalExistingSteps === FIRST_STEP) {
      newStep.send_from_launch_duration = Moment.duration(0, 'seconds').toISOString();
    } else {
      newStep.send_from_launch_duration = Moment
        .duration(steps[totalExistingSteps - 1].send_from_launch_duration)
        .add(DAYS_TO_ADD, 'd').toISOString();
    }

    newStep.sequence = sequence.id;

    await this.props.createStep(newStep);
    newStep.id = this.props.step.id;

    this.setState({
      steps: [
        ...steps,
        ...[newStep],
      ],
    });
  }

  addPitch = (currentStepIndex, copyPreviousPitch = false) => {
    const { steps } = this.state;
    const newPitch = cloneDeep(EMPTY_PITCH);
    if (copyPreviousPitch) {
      const previousPitch = last(steps[currentStepIndex].pitches);
      newPitch.subject = previousPitch.subject;
      newPitch.body = previousPitch.body;
    }
    steps[currentStepIndex].pitches = [
      ...steps[currentStepIndex].pitches,
      ...[newPitch],
    ];
    this.setState({
      steps,
      isAddPitchDialogOpen: false,
    });
  }

  showAddPitchDialog = (currentStepIndex) => {
    const { steps } = this.state;
    if (steps[currentStepIndex].pitches) {
      this.setState({
        isAddPitchDialogOpen: true,
        newPitchStepIndex: currentStepIndex,
      });
    } else {
      this.addPitch(currentStepIndex);
    }
  }

  canCreateOrEdit = () => {
    const { steps } = this.state;
    return steps.filter(step => step.pitches.find(pitch => !pitch.id || !pitch.collapsed)).length === 0;
  }

  toggleCustomizedEmailModal = () => {
    const { customizedEmailModalOpen } = this.state;
    this.setState({
      customizedEmailModalOpen: !customizedEmailModalOpen,
    });
  }

  overwriteCustomizedEmail = async (isOverwrite) => {
    const {
      pitchTemplateToUpdate, currentStepIndex, currentPitchIndex, steps,
    } = this.state;
    const pitchId = steps[currentStepIndex].pitches[currentPitchIndex].id;
    try {
      const params = isOverwrite ? { ...pitchTemplateToUpdate, remove_childs: true } : pitchTemplateToUpdate;
      await this.props.updatePitch(pitchId, params);
      steps[currentStepIndex].pitches[currentPitchIndex] = {
        ...cloneDeep(pitchTemplateToUpdate),
        id: pitchId,
        collapsed: true,
      };
      await this.getPitchTemplates();
      this.toggleCustomizedEmailModal();
      this.setState({
        steps,
      }, () => {
        this.canLaunch();
      });
    } catch (error) {
      if (error.errors) {
        throw new SubmissionError(error.errors);
      }
    }
  }

  savePitch = async (currentStepIndex, currentPitchIndex, formData, consentRequired = true) => {
    const { steps } = this.state;
    const { templatePitches, pitchQualityCheckData } = this.props;
    const pitchId = steps[currentStepIndex].pitches[currentPitchIndex].id;

    if (consentRequired && formData.is_template &&
      find(templatePitches.results, t => t.name.toLowerCase() === formData.name.toLowerCase())) {
      this.toggleIsConfirmModalOpen(currentStepIndex, currentPitchIndex, formData);
    } else {
      try {
        if (consentRequired && formData.is_template) {
          const pitchTemplateSubject = formData.inherits_subject ?
            this.getPitchSubject(steps, currentStepIndex) : formData.subject;
          await this.props.createTemplatePitch({
            account: this.props.sequence.account_id,
            ...formData,
            subject: pitchTemplateSubject,
          });
        }
        if (pitchId) {
          const childPitches = steps[currentStepIndex].pitches[currentPitchIndex].child_pitches;
          if (!isEmpty(childPitches)) {
            this.setState({
              customizedEmails: childPitches.length,
              customizedEmailModalOpen: true,
              pitchTemplateToUpdate: formData,
              currentStepIndex,
              currentPitchIndex,
            });
          } else {
            await this.props.updatePitch(pitchId, { ...formData, ...pitchQualityCheckData });
            steps[currentStepIndex].pitches[currentPitchIndex] = {
              ...cloneDeep(formData),
              id: pitchId,
              collapsed: true,
            };
          }
        } else {
          await this.props.createPitch({
            ...formData,
            ...pitchQualityCheckData,
            step: steps[currentStepIndex].id,
          });
          steps[currentStepIndex].pitches[currentPitchIndex] = {
            ...cloneDeep(formData),
            id: this.props.pitch.id,
            collapsed: true,
          };
        }
        await this.props.getSequence(this.props.sequence.id);
        await this.getPitchTemplates();
        this.setState({
          steps,
        }, () => {
          this.canLaunch();
        });

        this.props.getSteps({
          sequence: this.props.sequence.id,
        });
      } catch (error) {
        if (error.errors) {
          throw new SubmissionError(error.errors);
        }
      }
    }
    if (this.props.togglePitchPreview) this.props.togglePitchPreview(false);
    if (this.props.togglePitchQualityCheck) this.props.togglePitchQualityCheck(false);
    this.setFormNotSaved(false);
  }

  showNotification = (message, errorType = 'success') => {
    this.notification.notice({
      content: <BasicNotification
        color={errorType}
        message={message}
      />,
      duration: 6,
      closable: false,
      style: NOTIFICATION_NODE_STYLE,
      className: 'alert--colored right-up',
    });
  }

  destroyUnsavedPitchSteps() {
    const { steps } = this.state;
    steps.forEach((step) => {
      if (isEmpty(step.pitches) || !step.pitches[0].id) {
        this.props.destroyStep(step.id);
      }
    });
  }

  closePitch = (currentStepIndex, currentPitchIndex) => {
    this.setFormNotSaved(false);
    const { steps } = this.state;
    if (steps[currentStepIndex].pitches[currentPitchIndex].id) {
      steps[currentStepIndex].pitches[currentPitchIndex] = {
        ...steps[currentStepIndex].pitches[currentPitchIndex],
        collapsed: true,
      };
    } else {
      steps[currentStepIndex].pitches.splice(currentPitchIndex, 1);
    }
    if (isEmpty(steps[currentStepIndex].pitches)) {
      const step = steps.splice(currentStepIndex, 1);
      this.props.destroyStep(step[0].id);
    }
    this.setState({
      steps,
    });
  }

  expandPitch = (stepIndex, pitchIndex) => {
    const { steps } = this.state;

    if (this.state.formNotSaved) {
      this.showNotification('You must either cancel or save the pitch before viewing another one', 'danger');
      return;
    }

    // collapse all pitches
    const newSteps = steps.map((step) => {
      const transformedStep = step;
      transformedStep.pitches = step.pitches.map((pitch) => {
        const transformedPitch = pitch;
        transformedPitch.collapsed = true;
        return transformedPitch;
      });
      return transformedStep;
    });

    // expand selected pitch
    newSteps[stepIndex].pitches = steps[stepIndex].pitches.map((pitch, i) => {
      const transformedPitch = pitch;
      if (i === pitchIndex) {
        transformedPitch.collapsed = false;
      }
      return transformedPitch;
    });
    this.setState({
      steps: newSteps,
    });
  }

  destroyPitch = async (pitchId, currentStepIndex, currentPitchIndex) => {
    const { steps } = this.state;
    steps[currentStepIndex].pitches.splice(currentPitchIndex, 1);
    if (isEmpty(steps[currentStepIndex].pitches)) steps.splice(currentStepIndex, 1);
    this.setState({
      steps,
    }, () => {
      this.props.destroyPitch(pitchId);
      this.canLaunch();
    });
  }

  renderPitch = (pitch, currentStepIndex, currentPitchIndex) => {
    const inheritsSubject = currentStepIndex > 0 ? pitch.inherits_subject : false;
    return (
      <Pitch
        key={`pitch-${currentStepIndex}-${currentPitchIndex}`}
        name={pitch.name}
        subject={pitch.subject}
        body={pitch.body}
        errors={pitch.errors}
        is_template={pitch.is_template}
        inherits_subject={inheritsSubject}
        id={pitch.id}
        onSubmit={formData => this.savePitch(currentStepIndex, currentPitchIndex, formData)}
        onCancelPitch={this.closePitch}
        currentStepIndex={currentStepIndex}
        currentPitchIndex={currentPitchIndex}
        collapsed={pitch.collapsed}
        onExpandPitch={this.expandPitch}
        onDestroyPitch={this.destroyPitch}
        form={`pitch-${currentStepIndex}-${currentPitchIndex}`}
        setFormNotSaved={this.setFormNotSaved}
        initialValues={{
          body: pitch.body,
          collapsed: pitch.collapsed,
          is_template: pitch.is_template,
          name: pitch.name,
          subject: pitch.subject,
          inherits_subject: inheritsSubject,
        }}
        validatePitch={this.validatePitch}
        togglePitchPreview={this.props.togglePitchPreview}
        togglePitchQualityCheck={this.props.togglePitchQualityCheck}
        updatePitchPreviewData={this.props.updatePitchPreviewData}
        pitchQualityCheckOpen={this.props.pitchQualityCheckOpen}
      />
    );
  }

  renderStep = (step, key) => {
    const renderPitchBtn = key === 0 ||
      (this.state.steps[key - 1] && this.state.steps[key - 1].pitches.length > step.pitches.length);

    const disableDeleteBtn = this.state.steps[key + 1] &&
      this.state.steps[key + 1].pitches.filter(pitch => pitch.inherits_subject).length;

    return (
      <div className="step" key={`step-${key}`}>
        {key !== this.state.steps.length - 1 && <div className="step-container__line" />}
        <div className="step__title">
          <span className="step__circle" />
          <h4>{this.getStepTitle(step, key)}</h4>
          <Can I="delete" a="Step">
            <span className="delete_btn">
              <TrashCanIcon onClick={disableDeleteBtn ?
              () => this.showNotification('Subsequent step is inheriting subject', 'danger') :
              () => this.toggleDestroyModal(key)}
              />
            </span>
          </Can>
        </div>
        {step.pitches.map((pitch, pitchKey) => this.renderPitch(pitch, key, pitchKey))}
        <Can I="create" a="Pitch">
          {renderPitchBtn &&
            <div className="step__btn-contianer">
              <Button
                color="primary"
                variant="text"
                size="medium"
                disabled={!this.canCreateOrEdit()}
                onClick={() => this.showAddPitchDialog(key)}
                startIcon={<PlusCircleOutlineIcon />}
                fullWidth
              >
                {ADD_PITCH_BUTTON_TEXT}
              </Button>
            </div>
          }
        </Can>
      </div>
    );
  }

  render() {
    const {
      steps,
      customizedEmailModalOpen,
      customizedEmails,
      isUpdatePitchModalOpen,
      currentStepIndex,
      currentPitchIndex,
      isAddPitchDialogOpen,
      newPitchStepIndex,
    } = this.state;
    const lastStepHasNoPitches = steps.length && steps[steps.length - 1].pitches.length === 0;
    const newPitchIndex = steps.length && newPitchStepIndex !== null ? steps[newPitchStepIndex].pitches.length : -1;
    const newStepLoading = this.props.step.loading;
    return (
      <div className="steps-container">
        <CustomizedEmailModal
          customizedEmailModalOpen={customizedEmailModalOpen}
          toggleCustomizedEmailModal={this.toggleCustomizedEmailModal}
          customizedEmails={customizedEmails}
          overwriteCustomizedEmail={this.overwriteCustomizedEmail}
        />
        <DestroyModal funcToExecute={this.destroyStep} />
        {steps.map((step, k) => this.renderStep(step, k))}
        <Can I="create" a="Step">
          <div className="mt-3">
            <Button
              color="primary"
              variant="contained"
              size="medium"
              onClick={this.addStep}
              disabled={lastStepHasNoPitches || !this.canCreateOrEdit() || newStepLoading}
              fullWidth
            >
              {ADD_STEP_BUTTON_TEXT}
            </Button>
          </div>
        </Can>
        <ConfirmationModal
          open={isUpdatePitchModalOpen}
          onBackdropClick={() => this.toggleIsConfirmModalOpen()}
          title="Warning"
          confirmLabel="Update"
          confirmBtnColor="primaryCTA"
          onConfirmClick={() => this.updatePitch(currentStepIndex, currentPitchIndex)}
          onCancelClick={() => this.toggleIsConfirmModalOpen()}
        >
          <span>Pitch template already exist.</span>
          <br />Would you like to update it?
        </ConfirmationModal>
        <PitchAddModal
          open={isAddPitchDialogOpen}
          onCancelClick={() => this.onAddPitchDialogCancel()}
          onRejectClick={() => this.addPitch(newPitchStepIndex, false)}
          onAcceptClick={() => this.addPitch(newPitchStepIndex, true)}
          pitchIndex={newPitchIndex}
        />
      </div>
    );
  }
}

Steps.contextType = AbilityContext;

const connectStoreMethod = state => ({
  destroyModal: state.destroyModal,
  sequence: state.sequence,
  step: state.step,
  pitch: state.pitch,
  templatePitches: state.templatePitches,
});

const connectActionObject = {
  toggleDestroyModal,
  createStep,
  createPitch,
  updatePitch,
  destroyPitch,
  getPitches,
  getCsvTemplateFields,
  destroyStep,
  updateStep,
  updateSequence,
  getSequence,
  getSteps,
  getTemplatePitches,
  createTemplatePitch,
  updateTemplatePitch,
};

export default connect(
  connectStoreMethod,
  connectActionObject,
)(Steps);

export { Steps as StepsClass, connectStoreMethod, connectActionObject };
